import t from "./index9.js";
import { openBlock as r, createElementBlock as a, createElementVNode as o } from "vue";
import n from "../../../../_virtual/index.js";
const l = ["href"], s = ["src", "alt"];
function c(e, i, m, f, p, _) {
  return r(), a("div", null, [
    o("a", {
      class: "logo-bbb",
      href: e.link,
      target: "_blank"
    }, [
      o("img", {
        class: "logo-bbb-image",
        src: e.imageLink,
        alt: e.imageAlternateText
      }, null, 8, s)
    ], 8, l)
  ]);
}
const u = /* @__PURE__ */ n(t, [["render", c]]);
export {
  u as default
};
//# sourceMappingURL=index6.js.map
